export class NotFoundError extends Error {
  public code;

  constructor() {
    super();
    this.code = 404;
  }
}
